import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { setUrl } from "../../../../../helper/utils";
import chinaImg from "../../../../../assets/images/product/china.png";
import indiaImg from "../../../../../assets/images/product/india.png";

const ShippingCountry = () => {
  const [shippingCountry, setShippingCountry] = useState({
    india: false,
    china: false,
  });

  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();
  const location = useLocation();

  const handleShippingCountry = (e) => {
    if (e.target.name === "china") {
      setShippingCountry({ ...shippingCountry, china: !shippingCountry.china });
    } else if (e.target.name === "india") {
      setShippingCountry({ ...shippingCountry, india: !shippingCountry.india });
    }
  };

  useEffect(() => {
    let activeCountries = null;

    if (shippingCountry.india && shippingCountry.china) {
      activeCountries = "india,china";
    } else if (shippingCountry.india) {
      activeCountries = "india";
    } else if (shippingCountry.china) {
      activeCountries = "china";
    } else {
      activeCountries = null;
    }

    navigate(
      setUrl(
        location.pathname,
        searchParams,
        "shippingCountry",
        activeCountries
      )
    );

    // console.log("shippingCountry", shippingCountry, activeCountries);
  }, [shippingCountry.india, shippingCountry.china]);

  useEffect(() => {
    let countryArray = [];
    countryArray = searchParams.get("shippingCountry")?.split(",");
    if (
      countryArray?.some((item) => item === "china") &&
      countryArray?.some((item) => item === "india")
    ) {
      setShippingCountry({ india: true, china: true });
    } else if (countryArray?.some((item) => item === "india")) {
      setShippingCountry({ india: true, china: false });
    } else if (countryArray?.some((item) => item === "china")) {
      setShippingCountry({ india: false, china: true });
    } else {
      setShippingCountry({ india: false, china: false });
    }
  }, [location]);

  return (
    <div className="product_filteration_section">
      <div className="price_filteration">
        <h1 className="filter_heading">SHIPPING COUNTRY</h1>

        <div className="filter_items_list days_filter_list">
          <div className="filter_item">
            <input
              type="checkbox"
              id="india"
              value={shippingCountry.india}
              name="india"
              onChange={handleShippingCountry}
              checked={shippingCountry.india}
            />
            <label htmlFor="india">
              <span>India</span> <img src={indiaImg} alt="India" />
            </label>
          </div>

          <div className="filter_item">
            <input
              type="checkbox"
              id="china"
              value={shippingCountry.china}
              name="china"
              onChange={handleShippingCountry}
              checked={shippingCountry.china}
            />
            <label htmlFor="china">
              <span>China</span> <img src={chinaImg} alt="China" />
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingCountry;
